<mat-chip-set>
  <mat-chip style="background-color: #38A169; color: black" *ngIf="status === 'PUBLISHED'">
    <mat-icon aria-hidden="false" aria-label="Example home icon" svgIcon="file-upload"></mat-icon>
    <span>{{ "posts.filters.status.options.published" | translate }}</span>
  </mat-chip>
  <mat-chip style="background-color: #553C9A; color: black" *ngIf="status === 'WAITING_PAYMENT'">
    <mat-icon aria-hidden="false" aria-label="Example home icon" svgIcon="hand-stop"></mat-icon>
    <span>{{ "posts.filters.status.options.waiting_payment" | translate }}</span>
  </mat-chip>
  <mat-chip style="background-color: #FAF089; color: black" *ngIf="status === 'DRAFT'">
    <mat-icon aria-hidden="false" aria-label="Example home icon" svgIcon="device-floppy"></mat-icon>
    <span>{{ "posts.filters.status.options.draft" | translate }}</span>
  </mat-chip>
  <mat-chip style="background-color: #FC8181; color: BLACK" *ngIf="status === 'WAITING_VALIDATION'">
    <mat-icon aria-hidden="false" aria-label="Example home icon" svgIcon="device-floppy"></mat-icon>
    <span>{{ "posts.filters.status.options.waiting_validation" | translate }}</span>
  </mat-chip>
  <mat-chip style="background-color: #38B2AC; color: white" *ngIf="status === 'EXPIRED'">
    <mat-icon aria-hidden="false" aria-label="Example home icon" svgIcon="history"></mat-icon>
    <span>{{ "posts.filters.status.options.expired" | translate }}</span>
  </mat-chip>
  <mat-chip style="background-color: rgb(46, 46, 46); color: white" *ngIf="status === 'ARCHIVED'">
    <mat-icon aria-hidden="false" aria-label="Example home icon" svgIcon="archive"></mat-icon>
    <span>{{ "posts.filters.status.options.archived" | translate }}</span>
  </mat-chip>
</mat-chip-set>
